<template>
  <div class="row">
    <div class="col-sm-5">
      <div
        id="datatable_info"
        class="dataTables_info"
        role="status"
        aria-live="polite"
      >
        <!-- Showing {{ currentPage }} page of {{ totalItemCount }} entries -->
        {{ $t('common.totalCount') }}: {{ totalItemCount }}
        {{ $t('common.itemUnit') }}
      </div>
    </div>
    <div class="col-sm-7">
      <div
        id="datatable_paginate"
        class="dataTables_paginate paging_simple_numbers"
      >
        <ul class="pagination">
          <li
            id="datatable_previous"
            :class="{ disabled: isDisabledForPrevious }"
            class="paginate_button previous"
          >
            <a
              v-if="!isDisabledForPrevious"
              @click="changePage(currentPage - 1)"
              href="#"
              >Previous</a
            >
            <a v-else>Previous</a>
          </li>
          <template v-for="(page, key, index) in [...Array(totalPage)]">
            <li
              :key="index"
              :class="{ active: key + 1 === currentPage }"
              @click="changePage(key + 1)"
              class="paginate_button"
            >
              <a
                v-if="key + 1 !== currentPage"
                :data-dt-idx="key + 1"
                aria-controls="datatable"
                style="cursor: pointer;"
                tabindex="0"
                >{{ key + 1 }}</a
              >
              <a
                v-else
                :data-dt-idx="key + 1"
                @click="changePage(key + 1)"
                aria-controls="datatable"
                tabindex="0"
                >{{ key + 1 }}</a
              >
            </li>
          </template>
          <li
            id="datatable_next"
            :class="{ disabled: isDisabledForNext }"
            class="paginate_button next"
          >
            <a
              v-if="!isDisabledForNext"
              @click="changePage(currentPage + 1)"
              href="#"
              >Next</a
            >
            <a v-else>Next</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    pageParItemCount: Number,
    totalItemCount: Number,
    currentPage: Number,
  },
  computed: {
    totalPage: function() {
      return Math.ceil(this.totalItemCount / this.pageParItemCount)
    },
    isDisabledForPrevious: function() {
      return this.currentPage === 1 // true or false
    },
    isDisabledForNext: function() {
      return this.currentPage === this.totalPage // true or false
    },
  },
  methods: {
    changePage(page) {
      this.$emit('changePage', page)
    },
  },
}
</script>
